export default __webpack_public_path__ + "static/media/video.222ef922.mp4";